"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var Attention_1 = __importDefault(require("./Attention"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Subscriptions = function () {
    var _a, _b, _c;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _d = (0, swr_hooks_1.useUpdateReceivePromos)(), updateReceivePromos = _d.updateReceivePromos, isSubmitting = _d.isSubmitting;
    var data = (0, swr_hooks_1.useUser)().data;
    var _e = (0, react_1.useState)(false), isAttentionOpen = _e[0], setAttentionOpen = _e[1];
    var onCloseAttentionHandler = (0, react_1.useCallback)(function () {
        setAttentionOpen(false);
    }, []);
    var confirmUnsubscribeHandler = (0, react_1.useCallback)(function () {
        updateReceivePromos({
            receivePromos: false,
        });
        onCloseAttentionHandler();
    }, [onCloseAttentionHandler, updateReceivePromos]);
    var initialValues = {
        receiveEmailAndSMSPromos: ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.getOne) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.receivePromos)
            ? 'true'
            : 'false',
    };
    var onSubmitHandler = (0, react_1.useCallback)(function (values) {
        if (values['receiveEmailAndSMSPromos'] === 'false' && !isAttentionOpen)
            return setAttentionOpen(true);
        updateReceivePromos({
            receivePromos: values['receiveEmailAndSMSPromos'] === 'true',
        });
    }, [updateReceivePromos, setAttentionOpen, isAttentionOpen]);
    if (!data)
        return react_1.default.createElement(ui_components_1.LoadingWithContainer, null);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('automaticSubscriptionForEmailAndSMS')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('subscriptionIsRequiredToReceivePersonalizedOffers')),
        react_1.default.createElement(react_final_form_1.Form, { onSubmit: onSubmitHandler, initialValues: initialValues, render: function (_a) {
                var handleSubmit = _a.handleSubmit, values = _a.values;
                return (react_1.default.createElement("form", { onSubmit: handleSubmit },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.inputContainer },
                        react_1.default.createElement(react_final_form_1.Field, { name: "receiveEmailAndSMSPromos", type: "radio", value: "true", label: t('receiveEmailAndSMSPromos'), component: ui_components_1.InputRadiobox }),
                        react_1.default.createElement(react_final_form_1.Field, { name: "receiveEmailAndSMSPromos", component: ui_components_1.InputRadiobox, type: "radio", value: "false", label: t('doNotReceivePromos') })),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonContainer },
                        react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", type: "submit", text: "upper", loading: isSubmitting, disabled: values['receiveEmailAndSMSPromos'] ===
                                initialValues['receiveEmailAndSMSPromos'] }, t('save')))));
            } }),
        isAttentionOpen && (react_1.default.createElement(Attention_1.default, { onCloseHandler: onCloseAttentionHandler, onConfirmHandler: confirmUnsubscribeHandler }))));
};
exports.default = Subscriptions;
